export default "__VITE_ASSET__96fc6a17__"